/* eslint-disable global-require */

module.exports = {
    search_icon: {
        uri: 'https://img13.360buyimg.com/imagetools/jfs/t1/191146/19/27944/1930/63085cdcE518ae0a0/10256f832e8048ca.png'
    },
    down_arrow: {
        uri: 'https://img11.360buyimg.com/imagetools/jfs/t1/103250/8/32029/655/62fb416aE3d27dabc/b70c8b048564d539.png'
    },
    up_arrow: {
        uri: 'https://img13.360buyimg.com/imagetools/jfs/t1/52120/24/21510/629/62fb4188E3a3b806a/338700af09176181.png'
    },
    down_sort: {
        uri: 'https://img11.360buyimg.com/imagetools/jfs/t1/125871/27/29323/1238/63085ccfE1359d0ed/3e49a811ebec35c9.png'
    },
    up_sort: {
        uri: 'https://img14.360buyimg.com/imagetools/jfs/t1/9130/30/19377/623/63085cc9Eafbf89d9/3126d7c163d80421.png'
    },
    normal_sort: {
        uri: 'https://img13.360buyimg.com/imagetools/jfs/t1/103341/36/31034/592/63085cf9E05a6c1da/245397e19ba3a544.png'
    },
    chooseRed_right: {
        uri: 'https://img10.360buyimg.com/imagetools/jfs/t1/39451/35/18128/8977/630f4a8dE2c9c8667/94515694173a4dfa.png'
    },
    normal_sort_paixu: {
        uri: 'https://img14.360buyimg.com/imagetools/jfs/t1/121940/28/29978/942/63357515E0f004a8d/39bac9f84c05a081.png'
    },
    paixu_down: {
        uri: 'https://img10.360buyimg.com/imagetools/jfs/t1/15266/6/18810/2006/63357523Eb5b0c101/50a3a49b6fd44a84.png'
    },
    paixu_up: {
        uri: 'https://img11.360buyimg.com/imagetools/jfs/t1/54125/30/22260/1701/6335751bEab485415/a425ec9409186ef1.png'
    }
};
